import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { createStudent } from '../reducers/StudentSlice';
import { useNavigate } from 'react-router';

function AddStudent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    studentName: '',
    fatherName: '',
    email: '',
    dob: '',
    image: null,
    imagePreview: null,
    joinDate: '',
    gender: '',
    cnic: '',
    city: '',
    contactNumber: '',
    currentAddress: '',
    permanentAddress: '',
    emergencyContact: '',
    department: '',
    currentYear: '',
    semester: '',
    bloodGroup: '',
  });

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === 'file') {
      const file = files[0];
      if (file) {
        setFormData((prevData) => ({
          ...prevData,
          image: file,
          imagePreview: URL.createObjectURL(file),
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const submitData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null && key !== 'imagePreview') {
        submitData.append(key, formData[key]);
      }
    });

    try {
      const response = await dispatch(createStudent(submitData)).unwrap();
      if (response) {
        toast.success('Customer has been added!');
        navigate('/students');

        setFormData({
          studentName: '',
          fatherName: '',
          email: '',
          dob: '',
          image: null,
          imagePreview: null,
          joinDate: '',
          gender: '',
          cnic: '',
          city: '',
          contactNumber: '',
          currentAddress: '',
          permanentAddress: '',
          emergencyContact: '',
          department: '',
          currentYear: '',
          semester: '',
          bloodGroup: '',
        });
      } else {
        toast.error('An error occurred while adding the customer.');
      }
    } catch (error) {
      toast.error('An error occurred while adding the customer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-3 text-white py-3">
      <h2 className="text-center mb-4">Customer Form</h2>
      <form onSubmit={handleSubmit}>
        <div className="row g-3 mb-3">
          {[
            { id: 'studentName', label: 'Customer Name', type: 'text', required: true, placeholder: 'Enter Student Name' },
            { id: 'fatherName', label: 'Father Name', type: 'text', required: true, placeholder: 'Enter Father Name' },
            { id: 'email', label: 'Email', type: 'email', placeholder: 'Enter email' },
            { id: 'dob', label: 'Date of Birth', type: 'date' },
            { id: 'joinDate', label: 'Joining Date', type: 'date' },
            { id: 'cnic', label: 'Customer CNIC', type: 'text', placeholder: 'Enter CNIC' },
            { id: 'city', label: 'City', type: 'text', placeholder: 'Enter city' },
            { id: 'contactNumber', label: 'Contact Number', type: 'tel', required: true, placeholder: 'Enter contact number' },
            { id: 'currentAddress', label: 'Current Address', type: 'text', placeholder: 'Enter current address' },
            { id: 'permanentAddress', label: 'Permanent Address', type: 'text', placeholder: 'Enter permanent address' },
            { id: 'emergencyContact', label: 'Emergency Contact Number', type: 'tel', placeholder: 'Enter emergency contact number' },
            { id: 'department', label: 'Department', type: 'text', placeholder: 'Enter department' },
            { id: 'currentYear', label: 'Current Year', type: 'number', placeholder: 'Enter current year' },
            { id: 'semester', label: 'Semester', type: 'number', placeholder: 'Enter semester' },
            { id: 'bloodGroup', label: 'Blood Group', type: 'text', placeholder: 'Enter blood group' }
          ].map(({ id, label, type, required, placeholder }) => (
            <div key={id} className="col-md-4">
              <label htmlFor={id} className="form-label">{label}</label>
              <input
                type={type}
                className="form-control"
                id={id}
                name={id}
                placeholder={placeholder || ''}
                value={formData[id] || ''}
                onChange={handleChange}
                required={required || false}
              />
            </div>
          ))}

          {/* Gender Select Field */}
          <div className="col-md-4">
            <label htmlFor="gender" className="form-label">Gender</label>
            <select
              className="form-select"
              id="gender"
              name="gender"
              onChange={handleChange}
              value={formData.gender || ''}
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Student Picture Upload */}
          <div className="col-md-4">
            <label htmlFor="image" className="form-label">Customer Picture</label>
            <input
              type="file"
              className="form-control"
              id="image"
              name="image"
              accept="image/*"
              onChange={handleChange}
            />
            {formData.imagePreview && (
              <div className="mt-2">
                <img
                  src={formData.imagePreview}
                  alt="Preview"
                  className="img-thumbnail"
                  style={{ width: '150px', height: '150px' }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="text-center d-flex justify-content-end">
          <button
            type="submit"
            className="btn btn-primary text-white"
            disabled={loading}
            style={{ width: '165px' }}
          >
            {loading ? (
              <span>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Adding...
              </span>
            ) : (
              'Add Customer'
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddStudent;
